import {PAY_PER_USE_OPERATION_LABEL} from '../constants/PAY_PER_USE_OPERATION_LABEL';
import {getOperationTypeKey} from './getOperationTypeKey';

interface OperationTypeIdentity {
  resource: string;
  action: string;
}

/**
 * The aggregation key for an operation pair: the shared label key when the pair
 * is grouped, otherwise its own raw `${resource}/${action}` key. Pairs sharing
 * a group id are summed into one card / leaderboard column.
 */
export const getOperationGroupId = (operation: OperationTypeIdentity): string => {
  const key = getOperationTypeKey(operation);

  return PAY_PER_USE_OPERATION_LABEL[key] ?? key;
};
